import { Trans } from 'react-i18next'

import { getShelfColorByUnknownPercentage } from '@components/storeMap/utils'

const zeroPercentColor = getShelfColorByUnknownPercentage(0)
const fiftyPercentColor = getShelfColorByUnknownPercentage(50)
const hundredPercentColor = getShelfColorByUnknownPercentage(100)

export function HeatmapLegend() {
  return (
    <div
      className={`
        absolute right-0 bottom-0 flex h-22 gap-4 rounded-sm border border-border-primary bg-bg-tertiary p-4 opacity-100
        transition-all duration-500
        starting:opacity-0
      `}>
      <p className='w-32 text-sm'><Trans i18nKey='storeMap.layers.legendUnknownShare'/></p>
      <div className='flex h-full gap-2 text-sm'>
        <div className="flex flex-col items-end justify-between text-sm text-text-secondary">
          <p>0%</p>
          <p>100%</p>
        </div>
        <div
          className="h-full w-10"
          style={{ background: `linear-gradient(to bottom, ${zeroPercentColor}, ${fiftyPercentColor}, ${hundredPercentColor})` }}
        ></div>
      </div>
    </div>
  )
}